import { LayoutCard, Stack } from '@cast/design-system';

import { OptimizationProfile } from './OptimizationProfile';
import { SettingsSection } from './SettingsSection';

const Layout = ({
  children,
  testId,
}: {
  children: React.ReactNode;
  testId?: string;
}) => {
  return (
    <LayoutCard testId={testId}>
      <Stack gap={24}>{children}</Stack>
    </LayoutCard>
  );
};

export const Configuration = () => {
  return (
    <Layout testId="evictor-configuration">
      <OptimizationProfile />
      <SettingsSection />
    </Layout>
  );
};

const ConfigurationSkeleton = () => {
  return (
    <Layout testId="evictor-configuration-skeleton">
      <OptimizationProfile.Skeleton />
      <SettingsSection.Skeleton />
    </Layout>
  );
};

Configuration.Skeleton = ConfigurationSkeleton;
